export const frontendVersion = 'Last Frontend build 2024-07-01T11:17:43+00:00 [967308161d473e31be89b9bc187c9af071871014]'
